import { Trans } from "@lingui/macro";
import { Link } from "react-router-dom";
import cx from "classnames";

export default function UsefulLinks({ className }: { className?: string }) {
  const classNames = cx("Exchange-swap-market-box App-box App-box-border", className);
  return (
    <div className={classNames}>
      <div className="Exchange-swap-market-box-title">
        <Trans>Useful Links</Trans>
      </div>
      <div className="App-card-divider"></div>
      <div className="Exchange-info-row">
        <div className="Exchange-info-label-button">
          <Link to="/docs/trading-guide">
            <Trans>Trading Guide</Trans>
          </Link>
        </div>
      </div>
      <div className="Exchange-info-row">
        <div className="Exchange-info-label-button">
          <Link to="/leaderboard">
            <Trans>Leaderboard</Trans>
          </Link>
        </div>
      </div>
      <div className="Exchange-info-row">
        <div className="Exchange-info-label-button">
          <Link to="/docs/speed-up">
            <Trans>Speed Up Page Loading</Trans>
          </Link>
        </div>
      </div>
      <div className="Exchange-info-row">
        <div className="Exchange-info-label-button">
          <Link to="/docs/order-types">
            <Trans>Order Types</Trans>
          </Link>
        </div>
      </div>
      <div className="Exchange-info-row">
        <div className="Exchange-info-label-button">
          <Link to="/docs/fees">
            <Trans>Fees</Trans>
          </Link>
        </div>
      </div>
      <div className="Exchange-info-row">
        <div className="Exchange-info-label-button">
          <Link to="/docs/faq">
            <Trans>FAQ</Trans>
          </Link>
        </div>
      </div>
    </div>
  );
}
